import React from "react";
import Seo from "@/components/Seo";

const Box = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="font-heading font-bold text-xl sm:text-2xl text-slate-900 mb-3">{title}</h2>
    <div className="text-slate-700 leading-relaxed space-y-3">{children}</div>
  </section>
);

const PrivacyPage = () => (
  <>
    <Seo titleKey="seo.privacy_title" descKey="seo.privacy_desc" path="/politique-confidentialite" />
    <section className="container-x max-w-3xl pt-12 pb-20">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-blue">RGPD</p>
      <h1 className="mt-2 font-heading font-extrabold tracking-tighter text-4xl sm:text-5xl text-slate-900">Politique de confidentialité</h1>
      <p className="mt-4 text-slate-600">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}</p>

      <div className="mt-8">
        <Box title="Responsable de traitement">
          <p>Le responsable du traitement des données collectées sur ce site est BIONET SOLUTIONS, situé 64 chemin de Sermenaz, 01700 Neyron -contact@bionet-solutions.com.</p>
        </Box>

        <Box title="Données collectées">
          <p>Nous collectons uniquement les données nécessaires au traitement de vos demandes :</p>
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>Formulaire de devis :</strong> nom, prénom, téléphone, email, ville, code postal, type de prestation, surface, niveau d'urgence et description.</li>
            <li><strong>Formulaire de contact :</strong> nom, prénom, téléphone, email, ville et message.</li>
            <li><strong>Chatbot :</strong> contenu des échanges avec l'assistant (anonymes par défaut, sauf si vous communiquez vos coordonnées).</li>
            <li><strong>Données techniques :</strong> langue préférée et choix concernant les cookies (stockés localement).</li>
          </ul>
        </Box>

        <Box title="Finalités">
          <p>Les données sont utilisées exclusivement pour :</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Établir un devis personnalisé et organiser l'intervention.</li>
            <li>Répondre à vos demandes d'information.</li>
            <li>Améliorer la qualité de notre service via des statistiques agrégées.</li>
            <li>Respecter nos obligations légales et comptables.</li>
          </ul>
        </Box>

        <Box title="Base légale">
          <p>Le traitement repose sur votre consentement explicite (case RGPD du formulaire) et sur l'exécution d'un contrat ou de mesures précontractuelles à votre demande.</p>
        </Box>

        <Box title="Durée de conservation">
          <ul className="list-disc pl-6 space-y-1">
            <li>Devis non aboutis : 12 mois.</li>
            <li>Clients : durée de la relation contractuelle + 5 ans (obligations comptables et de garantie).</li>
            <li>Conversations chatbot : 6 mois maximum.</li>
            <li>Logs techniques : 12 mois maximum.</li>
          </ul>
        </Box>

        <Box title="Destinataires">
          <p>Les données ne sont jamais cédées à des tiers à des fins commerciales. Elles sont accessibles uniquement aux équipes habilitées de BIONET SOLUTIONS et à nos sous-traitants techniques (hébergement, envoi d'emails transactionnels), liés par un contrat conforme au RGPD.</p>
        </Box>

        <Box title="Sous-traitants">
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>Resend</strong> -envoi des emails transactionnels (UE/USA, conformité RGPD).</li>
            <li><strong>Anthropic</strong> -alimentation du chatbot (réponses générées par IA, sans entraînement sur vos données).</li>
            <li><strong>MongoDB Atlas</strong> ou hébergeur équivalent -stockage des données.</li>
          </ul>
        </Box>

        <Box title="Cookies">
          <p>Le site n'utilise pas de cookies publicitaires ou de mesure d'audience tiers par défaut. Seules deux entrées <em>localStorage</em> sont posées :</p>
          <ul className="list-disc pl-6 space-y-1">
            <li><code>i18nextLng</code> : votre langue préférée (FR/EN).</li>
            <li><code>bionet_cookie_consent</code> : votre choix vis-à-vis du bandeau cookies.</li>
          </ul>
          <p>Vous pouvez les supprimer à tout moment via les paramètres de votre navigateur.</p>
        </Box>

        <Box title="Vos droits">
          <p>Conformément aux articles 15 à 22 du RGPD, vous disposez des droits suivants : accès, rectification, suppression, limitation, portabilité, opposition. Pour les exercer, écrivez à <a href="mailto:contact@bionet-solutions.com" className="text-brand-blue hover:underline">contact@bionet-solutions.com</a>. Vous pouvez également introduire une réclamation auprès de la <strong>CNIL</strong> (cnil.fr).</p>
        </Box>

        <Box title="Sécurité">
          <p>Les communications transitent en HTTPS. Les mots de passe administrateur sont stockés sous forme hachée (bcrypt). Les sauvegardes et accès sont restreints au personnel autorisé.</p>
        </Box>
      </div>

      <p className="mt-8 text-xs text-slate-400">Pour toute question relative à vos données personnelles, contactez-nous à <a href="mailto:contact@bionet-solutions.com" className="underline">contact@bionet-solutions.com</a>.</p>
    </section>
  </>
);

export default PrivacyPage;
